import React, { useState } from 'react';

import { HeadingProps, HeadingPropsSchema } from '@usewaypoint/block-heading';

import BaseSidebarPanel, { SectionHeader } from './helpers/BaseSidebarPanel';
import SingleStylePropertyPanel from './helpers/style-inputs/SingleStylePropertyPanel';
import { Separator } from '@/components/ui/separator';

type HeadingSidebarPanelProps = {
  data: HeadingProps;
  setData: (v: HeadingProps) => void;
};

export default function HeadingSidebarPanel({ data, setData }: HeadingSidebarPanelProps) {
  const [, setErrors] = useState<Zod.ZodError | null>(null);

  const updateData = (d: unknown) => {
    const res = HeadingPropsSchema.safeParse(d);
    if (res.success) {
      setData(res.data);
      setErrors(null);
    } else {
      setErrors(res.error);
    }
  };

  return (
    <BaseSidebarPanel title="Heading block">
      {/* APPEARANCE SECTION */}
      <div className="space-y-4">
        <SectionHeader>Appearance</SectionHeader>
        <div className="space-y-3">
          <SingleStylePropertyPanel
            name="color"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
          <SingleStylePropertyPanel
            name="backgroundColor"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
        </div>
      </div>

      <Separator className="my-6" />

      {/* TYPOGRAPHY SECTION */}
      <div className="space-y-4">
        <SectionHeader>Typography</SectionHeader>
        <div className="space-y-3">
          <SingleStylePropertyPanel
            name="fontFamily"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
        </div>
      </div>

      <Separator className="my-6" />

      {/* LAYOUT SECTION */}
      <div className="space-y-4">
        <SectionHeader>Layout</SectionHeader>
        <div className="space-y-3">
          <SingleStylePropertyPanel
            name="textAlign"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
          <SingleStylePropertyPanel
            name="padding"
            value={data.style || {}}
            onChange={(style) => updateData({ ...data, style })}
          />
        </div>
      </div>
    </BaseSidebarPanel>
  );
}
